import ExpectationManagement from './expectation-management';

export default ExpectationManagement;
